import {
  SearchDisplayItemMasterRequest,
  DetailDisplayItemMasterRequest,
  UpdateDisplayItemMasterRequest,
  DeleteDisplayItemMasterRequest,
  CopyDisplayItemMasterRequest,
  UserListDisplayItemMasterRequest,
} from 'api-types/src/types/display-item-master';
import { ResponseGenerator } from 'common/type';
import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { deleteKeyEmpty } from 'utils';

import {
  getListSearchMenuItem,
  getDetailMenuItemAPI,
  updateDetailMenuItemAPI,
  getListScreenAPI,
  registerMenuDisplayAPI,
  exportExcelItemDisplayAPI,
  deleteDetailMenuItemAPI,
  getUserIdListDataAPI,
  copyItemDisplayAPI,
} from './api';
import {
  getListMenuDisplayItem,
  getListMenuDisplayItemSuccess,
  getListMenuDisplayItemFailure,
  getDetailMenuItem,
  getDetailMenuItemSuccess,
  updateDetailMenuItem,
  handleGetListScreenResponse,
  handleGetListScreenRequest,
  registerMenuDisplay,
  registerMenuDisplaySuccess,
  registerMenuDisplayFailure,
  exportExcelItemDisplaySuccess,
  exportExcelItemDisplay,
  deleteDetailMenuItem,
  getUserIdForCopyData,
  getUserIdForCopyDataSuccess,
  handleCopyItemDisplayResponse,
  handleCopyItemDisplayRequest,
  checkExistMenuItem,
  checkExistMenuItemSuccess,
} from './slice';

function* getMenuItemListSearchSaga({ payload }: { payload: SearchDisplayItemMasterRequest }) {
  const convertParams = deleteKeyEmpty({
    ...payload,
  });

  try {
    const response: ResponseGenerator = yield call(getListSearchMenuItem, convertParams);
    yield put(getListMenuDisplayItemSuccess(response.data));
  } catch (error) {
    yield put(getListMenuDisplayItemFailure({ loading: false }));
  }
}

function* getDetailMenuItemSaga({
  payload,
}: {
  payload: DetailDisplayItemMasterRequest & {
    onGetDataSuccess: () => void;
    onGetDataFail: () => void;
  };
}) {
  const { onGetDataSuccess, onGetDataFail, ...params } = payload;
  try {
    const response: ResponseGenerator = yield call(getDetailMenuItemAPI, params);
    yield put(getDetailMenuItemSuccess(response.data));
    onGetDataSuccess();
  } catch (error) {
    onGetDataFail();
  }
}

function* exportExcelItemDisplaySaga({ payload }: { payload: SearchDisplayItemMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(exportExcelItemDisplayAPI, payload);
    yield put(exportExcelItemDisplaySuccess(response as string));
  } catch (error) {
    console.log(error);
  }
}

function* updateDetailMenuItemSaga({
  payload,
}: {
  payload: UpdateDisplayItemMasterRequest & {
    onUpdateSuccess: () => void;
    onUpdateFail: () => void;
  };
}) {
  const { onUpdateSuccess, onUpdateFail, ...params } = payload;
  try {
    const response: ResponseGenerator = yield call(updateDetailMenuItemAPI, params);
    if (response.meta.code === 0) {
      return onUpdateSuccess();
    }
    onUpdateFail();
  } catch (error) {
    onUpdateFail();
  }
}

function* getListScreenSaga() {
  try {
    const response: ResponseGenerator = yield getListScreenAPI();
    yield put(handleGetListScreenResponse(response.data));
  } catch (error) {
    console.log(error);
  }
}

function* getUserIdForCopyDataSaga({ payload }: { payload: UserListDisplayItemMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getUserIdListDataAPI, payload);

    yield put(getUserIdForCopyDataSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}

function* handleCopyItemDisplaySaga({
  payload,
}: {
  payload: { data: CopyDisplayItemMasterRequest; onSuccess: () => void };
}) {
  const { data, onSuccess } = payload;
  try {
    const response: ResponseGenerator = yield call(copyItemDisplayAPI, data);

    yield put(handleCopyItemDisplayResponse(response.data));
    yield put(getUserIdForCopyData({}));
    onSuccess && onSuccess();
  } catch (error) {
    console.log(error);
  }
}

function* registerMenuDisplaySaga({
  payload,
}: {
  payload: UpdateDisplayItemMasterRequest & {
    onRegisterFail: () => void;
  };
}) {
  const { onRegisterFail, ...params } = payload;
  try {
    const response: ResponseGenerator = yield call(registerMenuDisplayAPI, params);
    if (response.meta.code === 0) {
      yield put(registerMenuDisplaySuccess({}));
    }
  } catch (error: any) {
    yield put(registerMenuDisplayFailure({ message: error?.message }));
    onRegisterFail();
  }
}

function* deleteDetailMenuItemSaga({
  payload,
}: {
  payload: DeleteDisplayItemMasterRequest & {
    onDeleteSuccess: (data: any) => void;
    onDeleteFail: (error: any) => void;
  };
}) {
  const { onDeleteSuccess, onDeleteFail, ...params } = payload;

  try {
    const response: ResponseGenerator = yield call(deleteDetailMenuItemAPI, params);
    onDeleteSuccess(response.data);
  } catch (error) {
    onDeleteFail(error);
  }
}

function* isItemExistMenuDisplaySaga({ payload }: { payload: SearchDisplayItemMasterRequest }) {
  const convertParams = deleteKeyEmpty({
    ...payload,
  });
  try {
    const response: ResponseGenerator = yield call(getListSearchMenuItem, convertParams);
    yield put(checkExistMenuItemSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}

function* watchMenuDisplayItem() {
  yield takeEvery(getListMenuDisplayItem, getMenuItemListSearchSaga);
  yield takeEvery(getDetailMenuItem, getDetailMenuItemSaga);
  yield takeLatest(updateDetailMenuItem, updateDetailMenuItemSaga);
  yield takeEvery(handleGetListScreenRequest, getListScreenSaga);
  yield takeEvery(getUserIdForCopyData, getUserIdForCopyDataSaga);
  yield takeEvery(registerMenuDisplay, registerMenuDisplaySaga);
  yield takeEvery(exportExcelItemDisplay, exportExcelItemDisplaySaga);
  yield takeEvery(deleteDetailMenuItem, deleteDetailMenuItemSaga);
  yield takeEvery(handleCopyItemDisplayRequest, handleCopyItemDisplaySaga);
  yield takeEvery(checkExistMenuItem, isItemExistMenuDisplaySaga);
}

export default watchMenuDisplayItem;
